import { render, staticRenderFns } from "./ResellerViewGlobal.vue?vue&type=template&id=70b0331d&"
import script from "./ResellerViewGlobal.vue?vue&type=script&lang=js&"
export * from "./ResellerViewGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports